import {readApiModel} from '../../libs/shared/core/src/helpers/api/apiHelpers';
import {reportToBugsnag} from '../../libs/shared/core/src/services/bugsnag/bugsnag';
import {ApiAiTaggingHarvestingReviewParameters} from '../models/api/ApiCommandLinkModel';
import {setAiTaggingHarvestingRuleBundleId} from '../store/panels/inboxes/inboxesPanelActions';

// NOTE: This currently only parses one type of command and payload,
// but this can be expanded to support more types in the future.
export function tryParseCommandLink(link: URL) {
  const path = link.pathname;

  const [command, encodedPayload] = path.split('/');

  if (!encodedPayload) {
    return null;
  }

  try {
    // Base64 decode and parse the stringified JSON.
    const src = JSON.parse(atob(encodedPayload));

    switch (command) {
      case 'ai_tagging_harvesting_review': {
        const params = readApiModel(ApiAiTaggingHarvestingReviewParameters, src);
        return setAiTaggingHarvestingRuleBundleId(params.ruleBundleId);
      }
      default:
        return null;
    }
  } catch (e) {
    reportToBugsnag(new Error(`Failed to parse command link: ${link}`));
    return null;
  }
}
